










import Vue from "vue";
import Component from "vue-class-component";

import Menu from "@/shared/components/menu.vue";
import Bar from '@/shared/components/bar.vue';
import { Usuario } from "@/services/home.service";
import { Prop } from "vue-property-decorator";

@Component({
  components: { Menu, Bar },
})
export default class Mobile extends Vue {
  drawer = false;

  @Prop({ default: null }) readonly usuario!: Usuario | null;

  onClick() {
    this.drawer = !this.drawer;
  }
}
